import type { OperationVariables, DataProxy } from '@apollo/client';
import { getApolloClientInternal } from './apolloClient';

export function writeFragment<TData = any, TVariables = OperationVariables>(
    options: DataProxy.WriteFragmentOptions<TData, TVariables>
) {
    return getApolloClientInternal().writeFragment(options);
}
